<template>
  <!-- 下发整改文件-->
  <el-dialog
    :title="title"
    :visible.sync="outerVisible"
    append-to-body
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleClose"
    width="60%"
  >
    <div class="file-content">
      <el-form label-width="100px" v-if="editStatus">
        <el-form-item label="红头标题：">
          <el-radio-group v-model="content.isRed">
            <el-radio :label="1">显示</el-radio>
            <el-radio :label="2">不显示</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="文件公章：">
          <el-radio-group v-model="content.isOfficialSeal">
            <el-radio :label="1">显示</el-radio>
            <el-radio :label="2">不显示</el-radio>
          </el-radio-group>
          <upload-image
            v-model="content.officialSeal"
            :uploadLimit="1"
            accept='image/*'
            style="width:90%"
          ></upload-image>
        </el-form-item>
      </el-form>
      <div>
        <div class="title" v-if="content.isRed == 1">
          <span v-if="!editStatus">{{ content.red }}</span>
          <el-input v-if="editStatus" v-model.trim="content.red"></el-input>
        </div>
        <div class="number" v-if="!editStatus">
          编号：{{ number ? number : "下发文件后会自动生成" }}
        </div>
        <div class="name">整改通知书</div>
        <div class="school-name">{{ content.schoolName }}</div>
        <div class="content1">
          <div v-if="editStatus">
            <el-input
              type="text"
              v-model.trim="content.content1"
              placeholder=""
            ></el-input>
          </div>
          <div v-if="editStatus">
            【隐患整改页面问题填写后，自动生成，显示例子如下：】
            <div>1.室外活动场所地位于楼下，高空抛物隐患大--不符合</div>
            2.校车座椅安全带过长，老化--不符合
          </div>
          <div v-if="!editStatus">{{ content.content1 }}</div>
          <div v-if="!editStatus">{{ selData.descriptionHiddenDangers }}</div>
        </div>
        <div class="content2">
          <div v-if="!editStatus">{{ content.content2 }}</div>
          <div v-if="editStatus">
            <el-input v-model.trim="content.content2" placeholder=""></el-input>
          </div>
        </div>
        <div class="content3">
          <div class="end-time" v-if="editStatus">
            【设置整改期限后，自动生成】
          </div>
          <span class="end-time" v-if="!editStatus"> {{ endTime }}</span>

          <span v-if="!editStatus">{{ content.content3 }}</span>
          <el-input
            v-if="editStatus"
            v-model.trim="content.content3"
            placeholder=""
          ></el-input>
        </div>
        <div class="content4">
          <div v-if="!editStatus">{{ content.content4 }}</div>
          <div v-if="editStatus">
            <el-input v-model.trim="content.content4" placeholder=""></el-input>
          </div>
          <div v-if="editStatus">【系统生成】年月日</div>
          <div v-if="!editStatus">{{ addTime }}</div>
        </div>
        <div class="content-bottom">
          <div class="official">
            签收单位（盖章）：
            <img
              class="official-seal"
              :src="$store.state.config.fileUrl + content.officialSeal"
              v-if="content.officialSeal != '' && content.isOfficialSeal == 1"
            />
          </div>
          <div class="sign">签收人：</div>
        </div>
        <div class="file-bottom">
          <el-button
            size="mini"
            type="primary"
            plain
            @click="edit"
            v-if="!editStatus"
          >
            编辑
          </el-button>
          <el-button
            size="mini"
            type="primary"
            plain
            @click="modify"
            v-if="editStatus"
          >
            确定
          </el-button>
          <el-button
            size="mini"
            type="primary"
            plain
            @click="cancel"
            v-if="editStatus"
          >
            取消
          </el-button>
          <el-button
            size="mini"
            type="primary"
            plain
            v-if="!editStatus && selData.rectificationFileId == 0"
            @click="issueFile"
          >
            确定并下发通知
          </el-button>

          <el-button
            size="mini"
            type="primary"
            plain
            v-if="!editStatus && selData.rectificationFileId != 0"
            @click="editFile"
          >
            修改下发文件
          </el-button>
          <el-button
            size="mini"
            type="primary"
            plain
            v-if="!editStatus"
            @click="handleClose"
          >
            返回
          </el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import moment from "moment";
import UploadImage from "@/components/UploadImage";
export default {
  name: "HiddenDangerSuperviseDialog",
  components: {
    UploadImage
  },
  props: {
    fileResize: {
      type: Number,
      default: {
        return: 0
      }
    },
    selData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      eduInfo: JSON.parse(sessionStorage.getItem("eduInfo")),
      title: "整改文件",
      outerVisible: false,
      req: {
        hiddenDangerId: "",
        schoolId: "",
        supervisorId: "", // 督办人 id
        streetOfficesId: ""
      },
      editStatus: false,
      content: {
        isRed: "", //是否显示红头文件1.是2.否
        isOfficialSeal: "", //是否显示公章1.是2.否
        officialSeal: "", //公章图片url
        red: "", //红头内容
        content1: "", //内容1
        content2: "", //内容2
        content3: "", //内容3
        content4: "" //内容4
      },
      addTime: "",
      endTime: "",
      number: "",
      intalData: {
        isRed: "", //是否显示红头文件1.是2.否
        isOfficialSeal: "", //是否显示公章1.是2.否
        officialSeal: "", //公章图片url
        red: "", //红头内容
        content1: "", //内容1
        content2: "", //内容2
        content3: "", //内容3
        content4: "" //内容4
      }
    };
  },
  created() {},
  mounted() {},
  watch: {
    fileResize: function(newVal) {
      if (newVal) {
        if (this.selData.rectificationFileId == 0) {
          this.show();
        } else {
          this.getFile();
        }
      }
    }
  },
  computed: {},
  methods: {
    handleClose() {
      this.content = Object.assign({}, this.intalData);
      this.number = "";
      this.editStatus = false;
      this.outerVisible = false;
    },
    // 显示默认文件
    show() {
      this.setData();
      this.outerVisible = true;
    },
    setData() {
      this.content.isRed = 1;
      this.content.isOfficialSeal = 2;
      this.content.red = this.eduInfo.eduBuresuName;
      this.content.officialSeal = "";
      this.content.schoolName = this.selData.schoolName;
      this.content.content1 =
        "我局在对你校（园）的工作检查中发现，你校（园）存在以下隐患（问题）：";
      this.content.content2 =
        "请你校（园）根据学校安全管理的相关规定，加强校园安全管理，严格落实整改措施，确保在";
      this.content.content3 =
        "将上述隐患（问题）整改到位，同时将整改落实情况书面报市教育局（安督办）。";
      this.content.content4 = this.eduInfo.eduBuresuName;
      this.content.schoolId = this.selData.schoolId;
      this.content.hiddenDangerId = this.selData.hiddenDangerId;

      this.addTime = moment().format("YYYY年MM月DD日");
      this.endTime = moment()
        .add(7, "days")
        .format("YYYY年MM月DD日");
      // console.log(this.addTime);
      // console.log(this.endTime);
    },
    edit() {
      this.editStatus = true;
    },
    modify() {
      this.editStatus = false;
    },
    cancel() {
      this.setData();
      this.editStatus = false;
    },
    // 查看下发文件内容
    async getFile() {
      let req = {
        id: this.selData.rectificationFileId
      };
      let res = await this.$Http.checkHiddenDangerSuperviseFile(req);
      if (res.code == 200) {
        this.content.id = res.data.id;
        this.content.isRed = res.data.isRed;
        this.content.isOfficialSeal = res.data.isOfficialSeal;
        this.content.red = res.data.red;
        this.content.officialSeal = res.data.officialSeal;
        this.content.schoolName = res.data.schoolName;
        this.content.content1 = res.data.content1;
        this.content.content2 = res.data.content2;
        this.content.content3 = res.data.content3;
        this.content.content4 = res.data.content4;

        this.number = res.data.number;
        let addTime = res.data.addTime * 1000;
        this.addTime = moment(addTime).format("YYYY年MM月DD日");
        this.endTime = moment(addTime)
          .add(7, "days")
          .format("YYYY年MM月DD日");

        this.outerVisible = true;
      } else if (res.code == 101) {
        this.$message({
          type: "info",
          message: "请先添加督办小组！"
        });
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 下发整改文件
    async issueFile() {
      let req = Object.assign({}, this.content, {
        educationBureauId: this.eduInfo.eduId
      });
      let res = await this.$Http.issueHiddenDangerSuperviseFile(req);
      if (res.code == 200) {
        this.outerVisible = false;
        this.$message("文件下发成功！");
        this.$parent.getHiddenDangerData();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 编辑整改文件
    async editFile() {
      let req = Object.assign({}, this.content);
      let res = await this.$Http.editHiddenDangerSuperviseFile(req);
      if (res.code == 200) {
        this.outerVisible = false;
        this.$message("文件编辑成功！");
        this.$parent.getHiddenDangerData();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.file-content {
  padding: 20px 50px;
  .title {
    font-size: 30px;
    color: #ff0000;
    text-align: center;
    border-bottom: 2px solid #ff0000;
    span {
      color: #ff0000;
    }
  }
  .number {
    color: #191919;
    text-align: right;
  }
  .name {
    padding-top: 30px;
    text-align: center;
    font-size: 24px;
    color: #191919;
  }
  .school-name {
    padding: 30px 0 20px 0;
    font-size: 16px;
    color: #191919;
  }
  .content2 {
    padding-top: 20px;
  }
  .content3 {
    padding-top: 20px;
  }
  .content4 {
    padding-top: 20px;
    text-align: right;
  }
  .content-bottom {
    padding-top: 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .official {
      position: relative;
      .official-seal {
        width: 100px;
        height: 100px;
        position: absolute;
        left: 60px;
        bottom: -10px;
      }
    }
    .sign {
      padding-right: 50px;
    }
  }
  .file-bottom {
    display: flex;
    justify-content: center;
    padding-top: 20px;
  }
}
</style>
